import { render } from "./ProfilePaymentReceipt.vue?vue&type=template&id=3dab15ce&ts=true"
import script from "./ProfilePaymentReceipt.vue?vue&type=script&lang=ts"
export * from "./ProfilePaymentReceipt.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__